import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { MdDone, MdClose } from 'react-icons/md';
import { IoChevronBack } from 'react-icons/io5';
import { useHistory } from 'react-router-dom';
import gs from '../../global.css';
import s from './style.css';
import { ActionButton } from '../../components';
import { vault } from '../../actions';
import { handleLinks } from '../../utils';
const ParsedText = ({ text }) => {
    useEffect(() => {
        handleLinks('note');
    }, []);
    return (React.createElement("p", { className: `${s.input} ${s.parsedText}`, id: 'note' }, text));
};
const CreateNoteScreen = ({ location, createVaultNote, updateVaultNote }) => {
    const [currentNote, setCurrentNote] = useState(location.state?.note || {});
    const [text, setText] = useState(currentNote.text || '');
    const [initialText, setInitialText] = useState(text);
    const [editing, setEditing] = useState(!currentNote.id);
    const history = useHistory();
    useEffect(() => {
        const input = document.getElementById('textarea');
        if (input) {
            input.selectionStart = text.length;
            input.selectionEnd = text.length;
        }
    }, [editing]);
    const handleSaveOrBackClick = (e) => {
        e.stopPropagation();
        if (editing) {
            if (text !== initialText) {
                setInitialText(text);
                if (currentNote.id) {
                    updateVaultNote({ note: currentNote, text });
                }
                else {
                    createVaultNote(text, (note) => setCurrentNote(note));
                }
            }
            setEditing(false);
        }
        else {
            history.push('/vault/notes');
        }
    };
    const handleCancelClick = () => {
        history.push('/vault/notes');
    };
    const handleEditClick = () => {
        setEditing(true);
    };
    const handleTextChange = (e) => {
        setText(e.target.value);
    };
    return (React.createElement("div", { className: gs.vaultMain },
        React.createElement("div", { className: gs.vaultScreenContainer },
            React.createElement("div", { className: s.stackContainer },
                React.createElement("div", { className: s.stackItem },
                    React.createElement("button", { type: 'button', className: s.stackItemTitle }, "Notes"))),
            React.createElement("div", { style: { display: 'flex', flexDirection: 'row' } },
                React.createElement(ActionButton, { onClick: handleSaveOrBackClick, text: editing ? 'Save' : 'Back', icon: editing ? React.createElement(MdDone, { fontSize: 20 }) : React.createElement(IoChevronBack, { fontSize: 20 }) }),
                editing && (React.createElement(ActionButton, { onClick: handleCancelClick, style: { marginLeft: 12 }, text: 'Cancel', icon: React.createElement(MdClose, { fontSize: 20 }) }))),
            React.createElement("div", { onClick: handleEditClick, onKeyDown: (e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                        handleEditClick();
                    }
                }, role: 'button', tabIndex: 0 }, editing ? (React.createElement("textarea", { id: 'textarea', value: text, onChange: handleTextChange, autoFocus: true, className: s.input, placeholder: 'Type your note here' })) : (React.createElement(ParsedText, { text: text }))))));
};
const connector = connect(null, { ...vault });
export default connector(CreateNoteScreen);
